import { logWrapper } from '../utils';

export default {
  contractModel: [
    'runtimeConstant',
    '$filter',
    'validationService',
    function (runtimeConstant, $filter, validationService) {
      function Contract(data) {
        if (!data) {
          data = {};
          data.Id = 0;
          data.Cnpj = '';
          data.CompanyName = '';
          data.ContractResponsible = '';
          data.ResponsibleSeller = '';
          data.UsersLimit = null;
          data.GbsLimit = null;
          data.ContractStatus = 1;
          data.ContractStart = null;
          data.UserCount = null;
        }

        this.id = data.Id;
        this.cnpj = data.Cnpj || '';
        this.companyName = data.CompanyName;
        this.contractResponsible = data.ContractResponsible;
        this.responsibleSeller = data.ResponsibleSeller;
        this.usersLimit = data.UsersLimit ? data.UsersLimit : 0;
        this.userCount = data.UserCount ? data.UserCount : 0;
        this.gbsLimit = data.GbsLimit ? data.GbsLimit : 0;
        this.startDate = data.StartDate
          ? new Date(Date.parse(data.StartDate))
          : null;
        this.companies = [];
        this.idContractStatus = data.IdContractStatus;

        this.allStatus = [
          { name: 'ACTIVE', id: 1 },
          { name: 'BLOQUED', id: 2 },
          { name: 'CANCELED', id: 3 },
        ];

        this.contractStatus = this.allStatus.filter(function (item) {
          return item.id === data.IdContractStatus;
        })[0];
      }

      function title() {
        return this.companyName;
      }

      function details() {
        if (this.startDate === null) {
          return 'Não possui data inicial.';
        } else if (this.contractStatus !== undefined) {
          return (
            $filter('translate')('CONTRACT START DATE TAG') +
            this.startDate.toLocaleDateString('pt-BR', {
              day: 'numeric',
              month: 'numeric',
              year: 'numeric',
            }) +
            ', ' +
            $filter('translate')('COMPANY STATUS') +
            ': ' +
            this.contractStatus.name
          );
        }
      }

      function tags() {
        var tags = [
          $filter('translate')('GBS LIMIT') +
            (this.gbsLimit ? this.gbsLimit : 'Ilimitado'),
        ];

        tags.push(
          $filter('translate')('USERS TAG') +
            (this.usersLimit
              ? this.userCount + ' de ' + this.usersLimit
              : 'Ilimitado')
        );

        return tags;
      }

      function isCnpjValid() {
        const cnpj = this.cnpj || '';

        return (
          cnpj.length === 0 ||
          validationService.validateCNPJ(cnpj)
        );
      }

      function isValid() {
        var isValid = true;

        isValid = this.isCnpjValid();

        return isValid;
      }

      function run() {
        try {
          Contract.prototype = {
            title: logWrapper(title, runtimeConstant.isDebugModelsInternals),
            details: logWrapper(
              details,
              runtimeConstant.isDebugModelsInternals
            ),
            tags: logWrapper(tags, runtimeConstant.isDebugModelsInternals),
            isCnpjValid: logWrapper(
              isCnpjValid,
              runtimeConstant.isDebugModelsInternals
            ),
            isValid: logWrapper(
              isValid,
              runtimeConstant.isDebugModelsInternals
            ),
          };

          return Contract;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
